import type { ShotContext } from './types';

export type Phase = 'shot1_risk' | 'shot2_address' | 'free_flow';

export interface SequenceState {
  phase: Phase;
  shotsCompleted: number;
}

export function initialState(): SequenceState {
  return { phase: 'shot1_risk', shotsCompleted: 0 };
}

export function contextForState(state: SequenceState): ShotContext {
  switch (state.phase) {
    case 'shot1_risk':
      return {
        category: 'Risk',
        label: 'Risk',
        description: 'Risk/Front Elevation',
        elevation: null,
        bracketColor: 'amber',
        locked: true,
      };
    case 'shot2_address':
      return {
        category: 'Risk',
        label: 'Address',
        description: 'Address Verification',
        elevation: null,
        bracketColor: 'pink',
        locked: true,
      };
    case 'free_flow':
      return {
        category: 'Exterior',
        label: 'Front Elevation',
        description: 'Overview',
        elevation: 'front',
        bracketColor: 'blue',
        locked: false,
      };
  }
}

export function advance(state: SequenceState): SequenceState {
  switch (state.phase) {
    case 'shot1_risk':
      return { phase: 'shot2_address', shotsCompleted: 1 };
    case 'shot2_address':
      return { phase: 'free_flow', shotsCompleted: 2 };
    case 'free_flow':
      return { phase: 'free_flow', shotsCompleted: state.shotsCompleted + 1 };
  }
}
